import styled from '@emotion/styled'
import {
  Divider as AntdDivider,
  TextStylePreset,
  Typography
} from '@vivaldis/antd-ui'
import { useTheme } from '@vivaldis/ui'
import { ReactNode } from 'react'

export interface InformationFieldWithTwoImagesProps {
  leftLabel: ReactNode
  rightLabel: ReactNode
  leftContent: ReactNode
  rightContent: ReactNode
  showDivider?: boolean
  smallDivider?: boolean
}

export const InformationFieldWithTwoImages = ({
  leftLabel,
  rightLabel,
  leftContent,
  rightContent,
  showDivider = false,
  smallDivider = true
}: InformationFieldWithTwoImagesProps) => {
  const theme = useTheme()
  return (
    <>
      <Base>
        <FieldBase>
          <FieldLabel>
            <Typography.Text
              preset={TextStylePreset.Regular12}
              color={theme.gray7}
              textAlign="left"
            >
              {leftLabel}
            </Typography.Text>
          </FieldLabel>
          <FieldValue>{leftContent}</FieldValue>
        </FieldBase>

        <FieldBase>
          <FieldLabel>
            <Typography.Text
              preset={TextStylePreset.Regular12}
              color={theme.gray7}
              textAlign="left"
            >
              {rightLabel}
            </Typography.Text>
          </FieldLabel>
          <FieldValue>{rightContent}</FieldValue>
        </FieldBase>
      </Base>
      {showDivider ? <Divider smallDivider={smallDivider} /> : null}
    </>
  )
}

const Base = styled('div')`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 16px;

  @media only screen and (max-width: 512px) {
    flex-direction: column;
    align-items: flex-start;
  }
`

const FieldBase = styled('div')`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  gap: 4px;
`

const FieldLabel = styled('div')`
  display: flex;
  min-width: 80px;
`

const FieldValue = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  min-width: 50px;
`

interface DividerProps {
  smallDivider?: boolean
}

const Divider = styled(AntdDivider, {
  shouldForwardProp: prop => prop !== 'smallDivider'
})<DividerProps>`
  border-top: 1px solid ${props => props.theme.gray4};
  ${props => (props.smallDivider ? 'margin: 8px 0;' : '')}
`
